import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';

/**
 * Registers the break attributes on the User model. They are only present in
 * the payload for the user themself and for moderators who may manage breaks.
 */
export function extendUser() {
  User.prototype.canGiveInteractionBreak = Model.attribute('canGiveInteractionBreak');
  User.prototype.interactionBreakMinutes = Model.attribute('interactionBreakMinutes');
  User.prototype.interactionBreakRemainingAtLoad = Model.attribute('interactionBreakRemaining');
}

/**
 * Seconds left on the user's break, counted down locally from the value the
 * server computed when the model was last refreshed. Using the server's
 * "remaining" (not a timestamp) keeps this correct even if the visitor's clock
 * is wrong.
 *
 * @param {import('flarum/common/models/User').default | null} user
 * @returns {number}
 */
export function remainingSeconds(user) {
  if (!user) return 0;

  const atLoad = user.interactionBreakRemainingAtLoad() || 0;
  if (atLoad <= 0) return 0;

  const elapsed = (Date.now() - user.freshness.getTime()) / 1000;

  return Math.max(0, Math.ceil(atLoad - elapsed));
}

/** @returns {string} m:ss */
export function formatRemaining(seconds) {
  const m = Math.floor(seconds / 60);
  const s = String(seconds % 60).padStart(2, '0');

  return `${m}:${s}`;
}
